import React from "react";
import { useSelector } from "react-redux";
import TrackOrderFooter from "components/track-order/TrackOrderFooter";
import TrackOrder from "components/track-order";
import useDelivertPickupFn from "features/hooks/useDelivertPickupFn";

function TrackOrderPage(props) {
  const { orderStatus, orderInfo } = useSelector((state) => state.order);

  const { goToSettings, goToLogin,goToHomePage  } = useDelivertPickupFn();

  return (
    <TrackOrder goBack={goToHomePage} goToLogin={goToLogin} goToSettings={goToSettings}>
      <TrackOrderFooter orderStatus={orderStatus} orderInfo={orderInfo} />
    </TrackOrder>
  );
}

export default TrackOrderPage;
